import { defineComponent as _defineComponent } from 'vue'
import { ApiValidationErrorViewModel } from "@/viewModels/apiErrorViewModel";
import { PropType, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
	/**
	 * 入力内容。
	 */
	modelValue: {
		type: String,
		required: true,
	},
	/**
	 * 入力フィールドの型。
	 */
	type: {
		type: String,
		required: true,
	},
	/**
	 * テキストエリア内のプレースホルダー内容。
	 */
	placeholder: {
		type: String,
		required: false,
		default: "",
	},
	/**
	 * 入力出来る最長文字列。
	 */
	maxlength: {
		type: Number,
		required: true,
	},
	/**
	 * 入力欄を無効化するかどうか。
	 */
	disabled: {
		type: Boolean,
		required: false,
		default: false,
	},
	/**
	 * テキストエリアに直接適用するクラス名。
	 * 標準のテキストエリアCSSに+αでカスタムしたいときに指定。
	 */
	customClass: {
		type: String,
		required: false,
		default: "",
	},
	/**
	 * 入力対象の識別子。
	 * APIバリデーションエラー時に使用するため、APIバリデーションエラー値と同値にすること。
	 * 例: `Contents`, `Reply.Contents`
	 */
	name: {
		type: String,
		required: true,
	},
	/**
	 * APIエラーオブジェクト。
	 */
	apiValidationErrorViewModel: {
		type: Object as PropType<ApiValidationErrorViewModel | null>,
		required: true,
		default: null,
	},
},
  setup(__props, { expose }) {
  expose()

const props = __props
/**
 * カスタマイズされたinput要素。
 * バリデーションエラー表示にも対応。
 * 本プロジェクト内部でinput要素を利用する場合は、原則このコンポーネントを使用する事。
 */



/**
 * inputタグにデフォルト設定されるクラス名。
 */
const defaultClass = "revico-community-talk-custom-input";

const errorMessage = computed(() => {
	if (!props.apiValidationErrorViewModel) return "";
	const targets = props.apiValidationErrorViewModel.details.filter((e) => e.target === props.name);
	return targets.map((e) => e.message).join(", ");
});

const __returned__ = { props, defaultClass, errorMessage }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})